import { BASE_DOMAIN, DEPRECATED_QUERY_REDIRECT_NAME, LOCALHOST, QUERY_REDIRECT_NAME } from './consts';

/**
 * XSS checking
 * проверяем на совпадение с базовыми доменами
 */
export const checkDomain = (url: URL): boolean => {
  let result = false;

  const domains = url.host.split('.').reverse();
  const baseDomains = BASE_DOMAIN.split('.').reverse();

  baseDomains.forEach((d, index) => {
    result = d === domains[index];
  });

  return result;
};

export const checkLocalhost = (url: URL): boolean => {
  return (
    url.hostname === LOCALHOST ||
    url.hostname === '127.0.0.1' ||
    /** Для локальной отладки допустим с телефона */
    url.hostname.startsWith('192.168.')
  );
};

export const getRedirectHref = (url: URL, configUrls) => {
  if (url.searchParams.has(DEPRECATED_QUERY_REDIRECT_NAME)) {
    return url.searchParams.get(DEPRECATED_QUERY_REDIRECT_NAME) || configUrls.afterLogin;
  }
  return url.searchParams.get(QUERY_REDIRECT_NAME) || configUrls.afterLogin;
};

export const getAuthorizationHeader = (token?: string) => ({ Authorization: token ? `Bearer ${token}` : '' });
